import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateLeaveRequest: ["leave_id", "leave"],
  updateLeaveSuccess: ["leavedata"],
  updateLeaveFailure: null,
});

export const UpdateLeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  leave_id: null,
  leavedata: null,
  leave: null,
});

export const UpdateLeaveSelectors = {
  getData: (state: any) => state.updateLeave.data,
  isFetching: (state: any) => state.updateLeave.fetching,
  isSuccess: (state: any) => state.updateLeave.success,
  hasError: (state: any) => state.updateLeave.error,
};

export const request = (state: any, { leave_id, leave }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
    leave: leave,
    leavedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { leavedata } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    leavedata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    leavedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_LEAVE_REQUEST]: request,
  [Types.UPDATE_LEAVE_SUCCESS]: success,
  [Types.UPDATE_LEAVE_FAILURE]: failure,
});
